<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`), disabled: true },
        { title: this.$t('accounts.title'), disabled: true }
      ]">
      <span slot="breadcrumbAfter" class="d-flex">
        <Searchable
          :querySearch.sync="querySearch"
        />
      </span>
    </Breadcrumbs>
    <!--<va-card id="accounts-page">-->
    <div class="d-flex justify-content-between align-items-center">
      <!--<h3 class="mb-0">
        {{$t('accounts.title')}}
      </h3>-->
      <transition name="fade" mode="out-in">
        <span v-if="isSearchingForAccounts" @click="isSearchingForAccounts = false" class="m-2">
          <va-icon name="material-icons close" class="clickable">close</va-icon>
        </span>

        <!-- <va-button v-if="!isSearchingForAccounts"
          key="btn-search-accounts"
          color="success"
          icon="fa fa-search"
          @click="isSearchingForAccounts = true">
          {{$t('accounts.search_accounts')}}
        </va-button> -->
      </transition>
    </div>

    <transition name="fade" mode="out-in">

      <div v-if="isSearchingForAccounts" key="accounts-search">
        <account-search></account-search>
      </div>

      <div v-if="!isSearchingForAccounts" key="accounts-table">
        <accounts-table :service="component.service" :querySearch="querySearch"></accounts-table>
      </div>

    </transition>
    <!--</va-card>-->
  </div>
</template>

<script>
import AccountSearch from './AccountSearch'
import AccountsTable from './AccountsTable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import { TABLE_CLINICAL_ACCOUNTS } from '@/local-storage/LocalStorageKeys'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    Searchable,
    Breadcrumbs,
    AccountsTable,
    AccountSearch
  },
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      isSearchingForAccounts: false,
      querySearch: '',
      customQueries: {},
      localStorageKey: TABLE_CLINICAL_ACCOUNTS
    }
  }
}
</script>
